<template>
  <div class="login-layout">
    <div class="new-flex" v-if="!signModel">
      <div>
        <v-layout>
          <v-img height="60" contain :src="require(`../../assets/${logoUrl}`)"></v-img>
        </v-layout>
        <div class="mx-auto mt-10"><!-- elevation-8 -->
          <v-card-text class="pa-0">
            <v-layout column>
              <v-card flat class=" card-box">
                <v-form ref="loginForm" autocomplete="off" class="mt-3">
                  <v-text-field v-model="model.username" outlined dense append-icon="mdi-account"
                    @keyup.enter="loginHandler" :rules="$_requiredValidation" id="username_field"
                    :label="$t('message.login.userName')" type="text" hide-details class="mb-3"
                    ref="usernameField"></v-text-field>
                  <v-text-field v-model="model.password" outlined dense id="password_field" :rules="$_requiredValidation"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" @keyup.enter="loginHandler"
                    :label="$t('message.login.password')" :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword" hide-details class="mb-3" autocomplete="new-password"></v-text-field>
                  <v-text-field v-model="hostRef" @keyup="doAlphaNumericConversion" outlined dense
                                @keyup.enter="loginHandler" id="domain" :rules="$_requiredValidation"
                                :label="$t('message.login.host')" type="text" :suffix="defaultHostTld" :hide-details="!domainHasMistake"
                                class="mb-3"></v-text-field>
                  <v-select append-icon="mdi-translate" id="lang_select" outlined dense hide-details
                    :label="$t('message.login.language')" :items="language" v-model="defaultLang" item-text="title"
                    item-value="value"></v-select>
                  <v-layout justify-center class="mt-5">
                    <v-btn class="button-deign" :loading="loading" @click="loginHandler">{{$t('message.layout.login') }}</v-btn>
                  </v-layout>
                  <v-layout justify-center>
                    <p class="my-3">{{ $t('message.layout.ortext') }}</p>
                  </v-layout>
                  <v-layout justify-center @click="rfidClick">
                    <v-btn class="button-deign">
                      {{ $t('message.layout.rfidsignin') }}
                    </v-btn>
                  </v-layout>
                </v-form>
              </v-card>
            </v-layout>
          </v-card-text>
        </div>
      </div>
    </div>
    <div class="new-flex" v-else>
      <div>
        <v-layout>
          <v-img height="60" contain :src="require(`../../assets/${logoUrl}`)"></v-img>
        </v-layout>
        <div class="mx-auto mt-10"><!-- elevation-8 -->
          <v-card-text class="pa-0">
            <v-layout column>
              <v-card flat class=" card-box">
                <v-form ref="rfidform" autocomplete="off" class="mt-3">
                  <v-text-field v-model="from.password" :rules="$_requiredValidation" outlined dense id="password_field"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :label="$t('message.layout.ScanRFID')"
                    :type="showPassword ? 'text' : 'password'" @click:append="showPassword = !showPassword" hide-details
                    class="mb-3" @keyup.enter="rfidHandler" ref="passwordField"></v-text-field>
                  <v-text-field v-model="hostRef" :rules="$_requiredValidation" @keyup="doAlphaNumericConversion" outlined dense
                                @keyup.enter="rfidHandler" id="domain" :label="$t('message.login.host')" type="text"
                                :suffix="defaultHostTld" :hide-details="!domainHasMistake" class="mb-3"></v-text-field>
                  <v-select append-icon="mdi-translate" id="lang_select" outlined dense hide-details
                    :label="$t('message.login.language')" :items="language" v-model="defaultLang" item-text="title"
                    item-value="value"></v-select>
                  <v-layout justify-center @click="signInPassword" class="mt-5">
                    <v-btn class="button-deign">
                      {{ $t('message.layout.SignInpassword') }}
                    </v-btn>
                  </v-layout>
                </v-form>
              </v-card>
            </v-layout>
          </v-card-text>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LOGIN, LOGIN_RFID } from '@/store/actionsTypes'

export default {
  data () {
    return {
      loading: false,
      model: {
        username: '',
        password: ''
      },
      from: {
        password: ''
      },
      hostRef: '',
      defaultLang: window.localStorage.getItem(process.env.VUE_APP_LOCALE_STORAGE) ? window.localStorage.getItem(process.env.VUE_APP_LOCALE_STORAGE) : 'no',
      showPassword: false,
      logoUrl: process.env.VUE_APP_LOGO_FILE_NAME,
      domainHasMistake: false,
      signModel: false
    }
  },
  computed: {
    language () {
      return [
        { title: this.$t('message.common.english'), value: 'en' },
        { title: this.$t('message.common.norwegian'), value: 'no' },
        { title: this.$t('message.common.lithuanian'), value: 'lt' },
        { title: this.$t('message.common.polish'), value: 'pl' },
        { title: this.$t('message.common.swedish'), value: 'sv' }
      ]
    },
    $_domainValidation () {
      return [
        val => {
          if (!val) {
            this.domainHasMistake = true
            return 'Required'
          }
          if (val.match(/^[0-9a-zA-Z]+$/)) {
            this.domainHasMistake = false
            return true
          } else {
            this.domainHasMistake = true
            return 'Invalid Domain Name'
          }
        }]
    },
    defaultHostTld () {
      return process.env.VUE_APP_STORE_HOST_DOMAIN
    },
    host () {
      const hostRef = this.hostRef.toLowerCase().replace(/[^0-9a-z]/g, '')

      if (!hostRef.includes(this.defaultHostTld)) {
        return `${hostRef}${this.defaultHostTld}`
      }

      return hostRef
    }
  },
  watch: {
    defaultLang () {
      this.$i18n.locale = this.defaultLang
      window.localStorage.setItem(process.env.VUE_APP_LOCALE_STORAGE, this.defaultLang)
    }
  },
  created () {
    this.hostRef = window.localStorage.getItem(process.env.VUE_APP_DOMAIN_CACHE_NAME) ?? ''
  },
  methods: {
    doAlphaNumericConversion () {
      this.hostRef = this.hostRef.substring(0, 13).replace(/[^A-Za-z1-9]/g, '')
    },
    loginHandler () {
      if (!this.$refs.loginForm.validate()) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'message.common.validationIssue' })
        return
      }

      window.localStorage.removeItem('TimerPwa_weekno')
      window.localStorage.removeItem('TimerPwa_year')

      this.loading = true

      this.$store
        .dispatch(LOGIN, {
          host: this.host,
          tenant: this.hostRef,
          email: this.model.username,
          password: this.model.password
        })
        .then((res) => {
          this.$router.push(res.redirectTo ?? '/dashboard')
        })
        .catch((e) => {
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t(e.message) })
        })
        .finally(() => {
          this.loading = false
        })
    },
    rfidHandler () {
      if (!this.$refs.rfidform.validate()) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'message.common.validationIssue' })
        return
      }

      window.localStorage.removeItem('TimerPwa_weekno')
      window.localStorage.removeItem('TimerPwa_year')

      this.loading = true

      this.$store
        .dispatch(LOGIN_RFID, {
          host: this.host,
          tenant: this.hostRef,
          rfid: this.from.password
        })
        .then((res) => {
          this.$router.push(res.redirectTo ?? '/dashboard')
        })
        .catch((e) => {
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t(e.message) })
        })
        .finally(() => {
          this.loading = false
        })
    },
    rfidClick () {
      this.signModel = true
      this.$nextTick(() => {
        this.$refs.passwordField.$refs.input.focus()
      })
    },
    signInPassword () {
      this.signModel = false
      this.$nextTick(() => {
        this.$refs.usernameField.$refs.input.focus()
      })
    }
  }
}
</script>

<style>
.border-styles {
  border-top-right-radius: 40px !important;
  border-bottom-left-radius: 40px !important;
}

.login .v-sheet--offset {
  top: -30px;
  position: relative;
}

.login-layout {
  position: fixed;
  background-color: #EEF1F5;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
}

.new-flex {
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  max-width: 500px;
  padding: 0 15px;
}
@media only screen and (max-width: 575px) {
  .new-flex {
    max-width: 100%;
  }
}

.card-box {
  padding: 30px 25px !important;
  border-radius: 10px !important;

}

.button-deign {
  width: 100%;
  padding: 14px 20px !important;
  border-radius: 18px !important;
  background-color: #3773e8 !important;
  height: unset !important;
}

.button-deign span {
  color: #fff;
}
</style>
